// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-banner[data-v-131aea70]{width:100%;padding-top:40px}@media(min-width:640px){.image-banner[data-v-131aea70]{padding-top:20px}}.image-banner img[data-v-131aea70]{width:100%;height:auto}", ""]);
// Exports
module.exports = exports;
